module.exports = __webpack_public_path__ + "static/media/SostenibilitàSistemica_ASSETS-Fish_24.8c330de2.png";